import script from "./ReservationSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReservationSummary.vue?vue&type=script&setup=true&lang=ts"

import "./ReservationSummary.vue?vue&type=style&index=0&id=0139fb34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0139fb34"]])

export default __exports__